module.exports = __webpack_public_path__ + "img/luyuanCustomerT2.791e74e3.png";